import { bindTooltip } from "../../../vendors/tooltips";

Vue.component("offer-card", {
	delimiters: ["{[{", "}]}"],
	props: ["card"],
	data() {
		return {
			offer: this.card,
			hiddenChannels: true,
			hiddenBonuses: true
		}
	},
	template: '#offer-card',

	updated() {
		bindTooltip();
	},
    methods: {
		showChannels(){
			if (!this.hiddenBonuses) {
				this.hiddenBonuses = true
			}
			this.hiddenChannels = !this.hiddenChannels;
		},
		showBonuses(){
			if (!this.hiddenChannels) {
				this.hiddenChannels = true
			}
			this.hiddenBonuses = !this.hiddenBonuses;
		}
	},
});